import { IconButton } from "@mui/material";
import clsx from "clsx";
import dialogStyles from "../dialogStyles.module.css";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import TodayIcon from "@mui/icons-material/Today";

interface Props {
  title: string;
  icon: any;
  onClick: () => void;
}

export default function CalendarToolButton({ title, icon, onClick }: Props) {
  return (
    <IconButton
      title={title}
      size="small"
      onClick={() => {
        onClick();
      }}
    >
      {icon}
    </IconButton>
  );
}
